var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',_vm._g(_vm._b({staticClass:"base-select",class:[("base-select-" + _vm.color)],attrs:{"clearable":"","placeholder":"请选择"}},'el-select',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }